import React, { FC, HTMLAttributes, useEffect, useState } from 'react';
import {
  Card,
  CardActions,
  CardMedia,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { ArrowForward } from '@material-ui/icons';
import { useHistory } from 'react-router';

import { Raffle } from '../../lib/types';
import { routes } from '../../router/routes';
import Countdown from '../Countdown';
import { getDisplayAmount } from '../../lib/accounts';
import { useStyles } from './styles';
import { useViewport } from '../../hooks/useViewport';

export interface RaffleCardProps extends HTMLAttributes<HTMLDivElement> {
  raffle: Raffle;
}

const MAX_TITLE_LENGTH = 20;

const RaffleCard: FC<RaffleCardProps> = ({
  raffle,
  className,
  ...otherProps
}) => {
  const { device } = useViewport();
  const classes = useStyles({ device });
  const { push } = useHistory();
  const [isEnded, setIsEnded] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timerId = setInterval(
      () => setIsEnded(new Date() < raffle.endTimestamp),
      1000
    );
    return () => clearInterval(timerId);
  }, [raffle, setIsEnded]);

  if (raffle.prizes.length === 0) return null;

  const prize = raffle.prizes[0];
  const imageUrl = raffle.metadata.overviewImageUri
    ? raffle.metadata.overviewImageUri
    : prize.meta.imageUri;

  return (
    <div
      className={`${classes.root}`} //relative nft-card bg-green-00 max-w-sm w-full md:w-6/12 lg:w-4/12 2xl:w-3/12 p-2.5
      {...otherProps}
    >
      <div className="relative bg-brand_smooth_gray rounded-xl p-4">
        {new Date() > raffle.endTimestamp ? (
          <div className={classes.cardEndedBadge}></div>
        ) : (
          <div className={classes.cardLiveBadge}></div>
        )}
        {raffle.featured && (
          <div className={classes.cardFeaturedBadge}>Featured</div>
        )}
        {!isLoaded && (
          <Skeleton
            variant="rect"
            animation={'wave'}
            classes={{
              root: classes.media,
            }}
          />
        )}
        <CardMedia
          component="img"
          className={classes.media}
          src={imageUrl}
          alt={prize.mint.name}
          style={isLoaded ? {} : { display: 'none' }}
          onLoad={() => setIsLoaded(true)}
        />

        <CardActions
          className={
            classes.raffleInfo +
            ' w-full bg-brand_smooth_gray text-brand_secondary'
          }
        >
          <div className={classes.detailsRow1 + ' w-full'}>
            {
              //@ts-ignore
              raffle?.prizes[0]?.meta?.name?.length > MAX_TITLE_LENGTH ? (
                <Tooltip title={raffle?.prizes[0]?.meta?.name} placement="top">
                  <div>
                    <p
                      className={`${classes.cardTitle} tracking-wider primary_font text-left w-full`}
                    >
                      {
                        //@ts-ignore
                        raffle?.prizes[0]?.meta?.name.slice(
                          0,
                          MAX_TITLE_LENGTH - 4
                        )
                      }{' '}
                      ...
                    </p>
                  </div>
                </Tooltip>
              ) : (
                <>
                  {
                    //@ts-ignore
                    <p
                      className={`${classes.cardTitle} tracking-wider primary_font text-left w-full`}
                    >
                      {raffle?.prizes[0]?.meta?.name}
                    </p>
                  }
                </>
              )
            }
          </div>
          <div className={classes.detailsRow2 + ' bg-green-00'}>
            <div className={classes.ticketsSold}>
              <div className={' text-brand_secondary'}>
                <span className={`${classes.cardSubtitle} primary_font`}>
                  Tickets Sold
                </span>
              </div>
              <div className={`${classes.cardData} primary_font`}>
                {raffle.totalTickets}
                {' / '}
                {raffle.entrantsCap}
              </div>
            </div>
            <div className={classes.ticketPrice}>
              <div>
                <div className={' text-brand_secondary'}>
                  <span className={`${classes.cardSubtitle} primary_font`}>
                    Ticket price
                  </span>
                </div>
                <div className={`${classes.cardData} primary_font`}>
                  {getDisplayAmount(
                    raffle.proceeds.ticketPrice,
                    raffle.proceeds.mint
                  )}{' '}
                  {raffle.proceeds.mint.symbol}
                </div>
              </div>
            </div>
          </div>
          <div
            style={{ margin: 0 }}
            className={
              classes.detailsRow3 +
              ' items-center justify-between w-full bg-green-00'
            }
          >
            <div className={' bg-red-00 items-center bg-yellow-00'}>
              <div className={`${classes.cardSubData} primary_font`}>
                {isEnded ? (
                  <Countdown
                    page="home"
                    endTimestamp={raffle.endTimestamp}
                    spacing={'1%'}
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="text-black bg-red-00 text-xs">
              <button
                onClick={() => {
                  push(`/raffle/${raffle.publicKey}`);
                }}
                className={`${classes.cardButton} primary_font`}
              >
                View Raffle
              </button>
            </div>
          </div>
        </CardActions>
      </div>
    </div>
  );
};

export default RaffleCard;


//'GTWalsheimProRegular font-bold rounded p-1 bg-brand_smooth_yellow'

//  return (
//    <Card
//      onClick={() => {
//        push(`/raffle/${raffle.publicKey}`);
//      }}
//      className={`${classes.root} ${className} w-full lg:w-3/12 md:w-6/12`}
//      {...otherProps}
//    >
//      {new Date() > raffle.endTimestamp && (
//        <div className={classes.cardEndedBadge}>Ended</div>
//      )}
//      {raffle.featured && (
//        <div className={classes.cardFeaturedBadge}>Featured</div>
//      )}
//      {!isLoaded && (
//        <Skeleton
//          variant="rect"
//          animation={'wave'}
//          classes={{
//            root: classes.media,
//          }}
//        />
//      )}
//      <CardMedia
//        component="img"
//        className={classes.media}
//        src={imageUrl}
//        alt={prize.mint.name}
//        style={isLoaded ? {} : { display: 'none' }}
//        onLoad={() => setIsLoaded(true)}
//      />

//      <CardActions className={classes.raffleInfo + ' w-full'}>
//        <div className={classes.detailsRow1 + ' w-full'}>
//          {
//            //@ts-ignore
//            raffle?.prizes[0]?.meta?.name?.length > MAX_TITLE_LENGTH ? (
//              <Tooltip title={raffle.metadata.name} placement="top">
//                <div>
//                  <p className="tracking-wider text-left w-full ">
//                    {
//                      //@ts-ignore
//                      raffle?.prizes[0]?.meta?.name.slice(
//                        0,
//                        MAX_TITLE_LENGTH - 4
//                      )
//                    }{' '}
//                    ...
//                  </p>
//                </div>
//              </Tooltip>
//            ) : (
//              <>
//                {
//                  //@ts-ignore
//                  <p className="tracking-wider text-left w-full ">
//                    {raffle?.prizes[0]?.meta?.name}
//                  </p>
//                }
//              </>
//            )
//          }
//        </div>
//        <div className={classes.detailsRow2}>
//          <div className={classes.ticketsSold}>
//            <div className={classes.label+" text-brand_secondary"}>
//              <span className={classes.cardLabel}>Tickets sold</span>
//            </div>
//            {raffle.totalTickets}
//          </div>
//          <div className={classes.endingIn}>
//            <div className={classes.label+" text-brand_secondary"}>
//              <span className={classes.cardLabel}>Ending in</span>
//            </div>
//            {isEnded ? (
//              <Countdown page="home" endTimestamp={raffle.endTimestamp} />
//            ) : (
//              '-'
//            )}
//          </div>
//        </div>
//        <div className={classes.detailsRow3}>
//          <div className={classes.ticketPrice}>
//            <div className={classes.label+" text-brand_secondary"}>
//              <span className={classes.cardLabel}>Ticket price</span>
//            </div>
//            {getDisplayAmount(raffle.proceeds.ticketPrice, raffle.proceeds.mint)}{' '}
//            {raffle.proceeds.mint.symbol}
//          </div>
//          <div>
//            <IconButton className={classes.goToRaffle}>
//              <ArrowForward />
//            </IconButton>
//          </div>
//        </div>
//      </CardActions>
//    </Card>
//  );
